<template>
    <section>
        <div class="company">
            <article>
                    <story theme="light" image="company-20181119.jpg" orderBy="text">
                        <h4>From Idea to Initiative</h4>
                        <p>One Dear Thing is an initiative within Galantus AB, developers of sustainability projects, primarily in the textile field.</p> 
                        <p>Galantus is managed by Maria Trapp and Marcus Bergman, and is based in Gothenburg, Sweden. Please visit <a href="http://www.galantus.se">www.galantus.se</a> for more information.</p>
                        <p>If you have questions or comments regarding One Dear Thing, you can reach us through <a href="mailto:info@onedearthing.com">info@onedearthing.com</a>. We are happy to answer any queries and will respond as quickly as possible.</p>
                        <p style="margin-top: 40px;">
                            One Dear Thing.<br/>
                            c/o Galantus AB<br/>
                            Kyrkogatan 13A<br/>
                            411 15 Gothenburg<br/>
                            SWEDEN
                        </p>
                    </story>
            </article>
        </div>
    </section>
</template>

<script>
import story from '@/components/stories/Story.vue'

export default {
    name: "Company",
    components: {
        story
    }
}
</script>

<style lang="postcss" scoped>
.company {
    padding-top: 14em;
    padding-bottom: 14em;
}
.underline {
    text-decoration: underline;
}
a { 
    text-decoration: none; 
    color: black; 
}
h4 {   
    margin-top: 0;
}

@media screen and (max-width: 780px) {
    .company {
        padding-top: 60px;
        padding-bottom: 0em;
    }

    h4 {   
        margin-top: 1em;
        font-size: 1.4em;
    }
}

</style>